export default {"src":"/_next/static/media/brown-badge.2d4c7609.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};